import React from "react";
import HtmlToString from "../../../components/Formatters/HtmlToString";
import PaginatedView from "../../../components/UI/PaginatedView/PaginatedView";
import { funcionalidades } from "../../../context/AuthContext";
import { apiRoutes } from "../../../hooks/apiClient";

const columns = [
  {
    name: "Tipo de Parte de Serviço",
    cell: (row) => row.nmTipoParteServico,
    maxWidth: "20%",
    sortable: true,
  },
  {
    name: "Tipo de Inaptidão",
    cell: (row) => (row.sqTipoInaptidao === 0 ? "-" : row.dsInaptidao),
    maxWidth: "50%",
  },
  {
    name: "Situação",
    cell: (row) => (row.ativo === "S" ? "Ativo" : "Inativo"),
    maxWidth: "130px",
    sortable: true,
    center: true,
  },
  {
    name: "Texto Padrão",
    cell: (row) => <HtmlToString html={row.txTextoPadrao} />,
    maxWidth: "50%",
  },
];

const ConsultaTextoParteServico = ({ history, match }) => (
  <PaginatedView
    title="Texto de Parte de Serviço"
    keyField="sqTextoParteServico"
    descriptionField="txTextoPadrao"
    defaultSearch
    defaultSearchPlaceholder="Digite o Texto de Parte de Serviço"
    queryService={apiRoutes.fiscalizacao.parametrizacao.consultaTextoParteServico}
    deleteService={apiRoutes.fiscalizacao.parametrizacao.excluiTextoParteServico}
    editRoute={`${match.url}/form`}
    columns={columns}
    permissionDelete={funcionalidades.textoTipoParteServico.deletar}
    permissionInsert={funcionalidades.textoTipoParteServico.inserir}
    history={history}
  />
);

export default ConsultaTextoParteServico;
